(function () {
  const TAG_MAP = {
    'badge-new': { label: 'Yeni', cls: 'noendy-badge--new', icon: '✨' },
    'badge-bestseller': { label: 'Çok satan', cls: 'noendy-badge--bestseller', icon: '🌟' },
    'badge-popular': { label: 'Popüler', cls: 'noendy-badge--popular', icon: '🔥' },
    'badge-limited': { label: 'Sınırlı', cls: 'noendy-badge--limited', icon: '⏳' },
    'badge-course': { label: 'Kurs', cls: 'noendy-badge--course', icon: '🎓' }
  };

  function readTags(card) {
    const raw = card.dataset.noendyTags || card.dataset.productTags || '';
    if (!raw) return [];
    return raw.split(',').map((s) => s.trim().toLowerCase()).filter(Boolean);
  }

  function injectBadges() {
    document.querySelectorAll('[data-noendy-tags], [data-product-tags]').forEach((card) => {
      if (card.querySelector('.noendy-card-badges')) return;
      const tags = readTags(card);
      if (tags.length === 0) return;
      const matched = tags
        .map((tag) => TAG_MAP[tag])
        .filter(Boolean);
      if (matched.length === 0) return;

      const container = document.createElement('div');
      container.className = 'noendy-card-badges';
      matched.forEach((b) => {
        const badge = document.createElement('span');
        badge.className = `noendy-badge ${b.cls}`;
        badge.innerHTML = `<span aria-hidden="true">${b.icon}</span><span>${b.label}</span>`;
        container.appendChild(badge);
      });

      const target = card.querySelector('.card__media, .card-wrapper__media, .media') || card;
      target.style.position = target.style.position || 'relative';
      target.appendChild(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectBadges);
  } else {
    injectBadges();
  }
  document.addEventListener('shopify:section:load', injectBadges);
})();
